// src/admin/AdminRegrasComunidade.js
import React, { useEffect, useState } from "react";
import {
  listCommunityRules,
  upsertCommunityRule,
  deleteCommunityRule,
} from "../services/timelineService";

export default function AdminRegrasComunidade() {
  const [loading, setLoading] = useState(true);
  const [rules, setRules] = useState([]);
  const [editing, setEditing] = useState(null); // { id?, order, title, text }

  async function reload() {
    setLoading(true);
    const list = await listCommunityRules();
    setRules(list);
    setLoading(false);
  }

  useEffect(() => {
    reload();
  }, []);

  function startNew() {
    const nextOrder = (rules.at(-1)?.order || rules.length) + 1;
    setEditing({ id: null, order: nextOrder, title: "", text: "" });
  }

  function startEdit(r) {
    setEditing({ id: r.id, order: r.order, title: r.title, text: r.text });
  }

  async function save() {
    if (!editing) return;
    const { id, order, title, text } = editing;
    if (!String(title).trim()) {
      alert("Dê um título à regra.");
      return;
    }
    await upsertCommunityRule({ id, order, title, text });
    setEditing(null);
    await reload();
  }

  async function remove(id) {
    if (!window.confirm("Remover esta regra?")) return;
    await deleteCommunityRule(id);
    await reload();
  }

  return (
    <div style={{ padding: 12 }}>
      <h2>Regras da Comunidade (Timeline)</h2>
      <p>Gerencie as regras exibidas no botão “Regras da comunidade” da Timeline.</p>

      {loading ? (
        <div>Carregando…</div>
      ) : (
        <>
          <div style={{ margin: "10px 0" }}>
            <button onClick={startNew} className="btn">+ Nova Regra</button>
          </div>

          {editing && (
            <div style={{ border: "1px solid #ccc", borderRadius: 8, padding: 12, marginBottom: 16 }}>
              <h3>{editing.id ? "Editar regra" : "Nova regra"}</h3>
              <div style={{ display: "grid", gap: 8, maxWidth: 680 }}>
                <label>
                  Ordem:
                  <input
                    type="number"
                    value={editing.order}
                    onChange={(e) => setEditing({ ...editing, order: Number(e.target.value) })}
                    style={{ width: 120, marginLeft: 8 }}
                  />
                </label>

                <label>
                  Título:
                  <input
                    type="text"
                    value={editing.title}
                    onChange={(e) => setEditing({ ...editing, title: e.target.value })}
                    style={{ width: "100%", marginLeft: 8 }}
                    placeholder="Ex.: Respeito acima de tudo"
                  />
                </label>

                <label>
                  Texto:
                  <textarea
                    value={editing.text}
                    onChange={(e) => setEditing({ ...editing, text: e.target.value })}
                    rows={4}
                    style={{ width: "100%" }}
                    placeholder="Descreva a regra…"
                  />
                </label>

                <div style={{ display: "flex", gap: 8 }}>
                  <button className="btn" onClick={save}>Guardar</button>
                  <button className="btn" onClick={() => setEditing(null)}>Cancelar</button>
                </div>
              </div>
            </div>
          )}

          {rules.length === 0 ? (
            <div>Nenhuma regra cadastrada.</div>
          ) : (
            <table className="admin-table" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left" }}>#</th>
                  <th style={{ textAlign: "left" }}>Título</th>
                  <th style={{ textAlign: "left" }}>Texto</th>
                  <th style={{ textAlign: "left" }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {rules.map((r) => (
                  <tr key={r.id}>
                    <td style={{ padding: "6px 8px" }}>{r.order}</td>
                    <td style={{ padding: "6px 8px", fontWeight: 700 }}>{r.title}</td>
                    <td style={{ padding: "6px 8px", opacity: .9 }}>{r.text}</td>
                    <td style={{ padding: "6px 8px" }}>
                      <button className="btn" onClick={() => startEdit(r)} style={{ marginRight: 6 }}>
                        Editar
                      </button>
                      <button className="btn" onClick={() => remove(r.id)}>
                        Apagar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}
    </div>
  );
}
